import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";

import BiddingSuggestionsModal from "./components/BiddingSuggestionsModal";
import {
  CLOSE_COOLDOWN_MS,
  IDLE_MS,
  isEligibleBiddingSuggestionsPage,
  isOptedOut,
  isWithinCloseCooldown,
  markModalDismissed,
} from "./utils";

// Only intentional clicks reset the idle timer; navigation is handled in componentDidUpdate.
const ACTIVITY_EVENTS = ["click"];
const STARTUP_GRACE_MS = 2000;

class BiddingSuggestionsListener extends PureComponent {
  state = { showModal: false };

  componentDidMount() {
    this.startListener();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      this.clearDismissedTimer();
      this.stopListener();
      this.setState({ showModal: false });
      this.startListener();
    }
  }

  componentWillUnmount() {
    this.clearDismissedTimer();
    this.stopListener();
  }

  clearDismissedTimer = () => {
    clearTimeout(this.dismissedTimer);
  };

  canShowPopup = () => {
    const { location } = this.props;
    return (
      isEligibleBiddingSuggestionsPage(location.pathname) &&
      !isOptedOut() &&
      !isWithinCloseCooldown()
    );
  };

  startListener = () => {
    if (!this.canShowPopup()) {
      return;
    }

    this.ignoreActivityUntil = Date.now() + STARTUP_GRACE_MS;
    this.resetIdleTimer();
    ACTIVITY_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, this.handleActivity, { passive: true });
    });
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  };

  stopListener = () => {
    clearTimeout(this.idleTimer);
    ACTIVITY_EVENTS.forEach((eventName) => {
      document.removeEventListener(eventName, this.handleActivity);
    });
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  };

  handleActivity = () => {
    if (this.state.showModal || Date.now() < this.ignoreActivityUntil) {
      return;
    }
    this.resetIdleTimer();
  };

  handleVisibilityChange = () => {
    if (document.hidden) {
      clearTimeout(this.idleTimer);
      return;
    }
    if (!this.state.showModal && this.canShowPopup()) {
      this.resetIdleTimer();
    }
  };

  resetIdleTimer = () => {
    clearTimeout(this.idleTimer);
    if (!this.canShowPopup()) {
      return;
    }
    this.idleTimer = setTimeout(this.showPopup, IDLE_MS);
  };

  showPopup = () => {
    if (!this.canShowPopup()) {
      return;
    }
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    markModalDismissed();
    this.setState({ showModal: false });
    this.stopListener();
    this.clearDismissedTimer();
    this.dismissedTimer = setTimeout(() => {
      if (this.canShowPopup()) {
        this.startListener();
      }
    }, CLOSE_COOLDOWN_MS);
  };

  render() {
    const { showModal } = this.state;
    if (!showModal) {
      return null;
    }

    return (
      <BiddingSuggestionsModal show={showModal} onClose={this.handleCloseModal} />
    );
  }
}

export default withRouter(BiddingSuggestionsListener);
